import { createRoot } from "react-dom/client";

import App from "./App";

import "semantic-ui-css/semantic.min.css";


const MOUNT_NODE = document.getElementById("root") as HTMLElement;

createRoot(MOUNT_NODE).render(<App />);
